import * as React from 'react';
import { Route, useLocation, Routes } from 'react-router';

import { PathTemplate } from '@notino/shared/definitions/types';

import ProductDetail from '@containers/ProductDetailContainer';
import { TemporaryWishlistRouting } from '@containers/WishList/TemporaryWishlistRouting';
import { useResolveWebView } from '@queries/useResolveWebView';

import loadables from '../../containers/App/loadables';
import { PageLoadFailed } from '../NotFound';

const WebView: React.FC<{
  mountId?: string;
  originUrl?: string;
  productDetailSsrEnabled?: boolean;
  productPath?: string;
}> = ({ originUrl, productDetailSsrEnabled }) => {
  const { pathname } = useLocation();
  const { resolveWebViewData, resolveWebViewError, resolveWebViewLoading } =
    useResolveWebView({ originUrl, pathname });

  if (resolveWebViewLoading) {
    return null;
  }
  if (resolveWebViewError) {
    return <PageLoadFailed reason="unable resolve url" />;
  }

  if (!resolveWebViewData) {
    return <PageLoadFailed reason="no data returned" />;
  }

  switch (resolveWebViewData.resolveUrl.type) {
    case PathTemplate.ProductDetailSimple:
      return (
        <Routes>
          <Route
            path="*"
            element={
              <ProductDetail
                catalogId={Number(resolveWebViewData.resolveUrl.catalogId)}
                productId={Number(resolveWebViewData.resolveUrl.productId)}
                ssrEnabled={productDetailSsrEnabled ?? false}
              />
            }
          />
        </Routes>
      );

    case PathTemplate.ReviewsPage:
      return (
        <Routes>
          <Route
            path="*"
            element={
              <loadables.ReviewsPage
                ssrEnabled={true}
                productId={Number(resolveWebViewData.resolveUrl.productId)}
                catalogId={Number(resolveWebViewData.resolveUrl.catalogId)}
              />
            }
          />
        </Routes>
      );

    case PathTemplate.Wishlist:
      return (
        <Routes>
          <Route
            path="/wishlist/shared/:sharedListId"
            element={<loadables.WishList />}
          />
          <Route path="/wishlist/:listId" element={<loadables.WishList />} />
          <Route path="*" element={<TemporaryWishlistRouting />} />
        </Routes>
      );

    case PathTemplate.Error:
      return (
        <Routes>
          <Route path="/error/:errorType" element={<loadables.ErrorPage />} />
        </Routes>
      );

    case PathTemplate.HomePage:
      return (
        <Routes>
          <Route path="/" element={<loadables.Home />} />
        </Routes>
      );

    default:
      return <div>Not found</div>;
  }
};

export default WebView;
